import RandingStyle17 from "../../randing/RandingStyle17";
// import { Helmet } from "react-helmet";

function Randing077({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle17
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_01.jpg`}
      video1Thumbnail={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_02.jpg`}
      video1Path={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_02(01).mp4`}
      // video2Thumbnail={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_02.jpg`}
      video2Path={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_02(02).mp4`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_03.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_04.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_04-2.jpg`}
      formFieldColor="white"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/navy/benefitArrowButton.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton3.png`}
      companyName="본원"
      apiUrl={apiUrl}
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing077;
